<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Payments & Loyalty</div>
		<div class="ms-auto">
			<app-record-control-footer
				(onSaveChange)="onSave()"
				[saveDisabled]="!changesToSave"
				[hideCancel]="true"
				[hideDelete]="true"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'credit-card']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Credit Card</div>
			</ng-template>
			<app-payment-processor-setup [(changesToSave)]="changesToSave"></app-payment-processor-setup>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'gift-card']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Gift Card</div>
			</ng-template>
			<div class="p-grid mt-2">
				<div class="p-col-12 p-lg-6 d-flex flex-column">
					<div>
						<span class="p-float-label">
							<p-dropdown
								autoDisplayFirst="false"
								id="giftProcessor"
								[(ngModel)]="venueSvc.ooVenue.giftProcessor"
								[options]="giftProcessors"
								[style]="{ width: '100%' }"
								(onChange)="changesToSave = true"
							>
							</p-dropdown>
							<label for="giftProcessor">Gift Card Processor</label>
						</span>
					</div>
					<div class="mt-4">
						<span class="p-float-label">
							<input
								[disabled]="!venueSvc.ooVenue.giftProcessor || venueSvc.ooVenue.giftProcessor === 2"
								id="giftApiKey"
								pInputText
								class="w-100"
								type="text"
								(onChange)="changesToSave = true"
								[(ngModel)]="venueSvc.ooVenue.giftApiKey"
							/>
							<label for="giftApiKey">Gift API Key</label>
						</span>
					</div>
					<div class="mt-4">
						<span class="p-float-label">
							<input
								[disabled]="!venueSvc.ooVenue.giftProcessor || venueSvc.ooVenue.giftProcessor === 2"
								id="giftApiSecret"
								pInputText
								class="w-100"
								type="text"
								(onChange)="changesToSave = true"
								[(ngModel)]="venueSvc.ooVenue.giftApiSecret"
							/>
							<label for="giftApiSecret">Gift API Secret</label>
						</span>
					</div>
				</div>
			</div>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'hands-heart']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Loyalty</div>
			</ng-template>
			<div class="p-grid mt-2">
				<div class="p-col-12 p-lg-6 d-flex flex-column">
					<div>
						<span class="p-float-label">
							<p-dropdown
								autoDisplayFirst="false"
								id="loyaltyProcessor"
								[(ngModel)]="venueSvc.ooVenue.loyaltyProcessor"
								[options]="loyaltyProcessors"
								[style]="{ width: '100%' }"
								(onChange)="changesToSave = true"
							>
							</p-dropdown>
							<label for="loyaltyProcessor">Loyalty Processor</label>
						</span>
					</div>
					<div class="mt-4">
						<span class="p-float-label">
							<input
								[disabled]="!venueSvc.ooVenue.loyaltyProcessor"
								id="loyaltyApiKey"
								pInputText
								class="w-100"
								type="text"
								(onChange)="changesToSave = true"
								[(ngModel)]="venueSvc.ooVenue.loyaltyApiKey"
							/>
							<label for="loyaltyApiKey">Loyalty API Key</label>
						</span>
					</div>
					<div class="mt-4">
						<span class="p-float-label">
							<input
								[disabled]="!venueSvc.ooVenue.loyaltyProcessor"
								id="loyaltyApiSecret"
								pInputText
								class="w-100"
								type="text"
								(onChange)="changesToSave = true"
								[(ngModel)]="venueSvc.ooVenue.loyaltyApiSecret"
							/>
							<label for="loyaltyApiSecret">Loyalty API Secret</label>
						</span>
					</div>
				</div>
			</div>
		</p-tabPanel>
	</p-tabView>
</div>
